import { GET_STARTUP_DATA } from './../constants/actionTypes'

const startup = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_STARTUP_DATA:
      return action.data.data
    default:
      return store
  }
}

export default startup
